var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { AbstractRepository } from 'packages/core/AbstractRepository';
import { FeatureConfiguration } from 'packages/features/FeatureConfiguration';
import { Authenticator } from 'packages/authentication/services/Authenticator';
import { injectable } from 'tsyringe';
import { EntityBuilder } from '@decahedron/entity';
var FeatureRepository = /** @class */ (function (_super) {
    __extends(FeatureRepository, _super);
    function FeatureRepository(authenticator) {
        var _this = _super.call(this) || this;
        _this.authenticator = authenticator;
        _this.entity = FeatureConfiguration;
        _this.url = 'companies/:company/features';
        return _this;
    }
    FeatureRepository.prototype.retrieve = function (companyId) {
        var _this = this;
        return this.get(this.url, { company: companyId.toString() })
            .then(function (r) { return _this.responseTransformer(r); })
            .then(function (data) { return EntityBuilder.buildOne(FeatureConfiguration, data.data); });
    };
    FeatureRepository.prototype.set = function (companyId, features) {
        return this.put(this.url, features.toJson(), { company: companyId });
    };
    var _a;
    FeatureRepository = __decorate([
        injectable(),
        __metadata("design:paramtypes", [typeof (_a = typeof Authenticator !== "undefined" && Authenticator) === "function" ? _a : Object])
    ], FeatureRepository);
    return FeatureRepository;
}(AbstractRepository));
export { FeatureRepository };
